// eslint-disable-next-line import/prefer-default-export
export const ERROR_MESSAGES = {
  LARGE: "The image cannot be larger than 10MB!",
  SMALL: "The image dimensions cannot be less than 1600x1064px!",
  width: minWidth => `The image width cannot be less than ${minWidth}px!`,
  height: minHeight => `The image height cannot be less than ${minHeight}px!`
};
